import { createContext, useContext } from 'react';
import { LayoutContextValue } from '../types';

export const LayoutContext = createContext<LayoutContextValue>(undefined!);

export const useLayout = () => {
  return useContext(LayoutContext);
};
